import { zod4Resolver } from 'mantine-form-zod-resolver'
import { useSummaryForm } from '../hook/summary-form'
import { summaryProductValidation } from './validation'

export const useSummaryProductForm = () => {
  return useSummaryForm({
    mode: 'controlled',
    cascadeUpdates: true,
    validate: zod4Resolver(summaryProductValidation()),
    initialValues: {
      sku: '',
      ali_sku: '',
      title: '',
      slug: '',
      description: '',
      visibility: '0',
      not_show_in_catalog: '',
      status: '',
      for_export_only: false,
      priority: 0,
      supplier_id: null,
      brand_id: null,
      warehouses: null,
      country_id: null,
      province_id: null,
      city_id: null,
      district_id: null,
      original_currency: '',
      regular_price: 0,
      sale_price: 0,
      reseller_price: 0,
      markup_percentage: 0,
      reward_point: 0,
      base_qty_review: 0,
      base_average_review_point: 0,
      base_qty_sold: 0,
      group_qty: 0,
      quantity: 0,
      minimum_qty: 1,
      quantity_unit: null,
      weight: 0,
      weight_unit: '',
      qty_per_cbm: 0,
      note: '',
      tags: [],
      po_ship_from: null,
      po_shipment_method: null,
      dimension_unit: '',
      dimensions: [
        {
          label: '',
          value: 0
        }
      ],
      categories: [],
    },
    transformValues: (values) => {
      return {
        ...values,
        brand_id: values.brand_id ? Number(values.brand_id) : null,
        supplier_id: values.supplier_id ? Number(values.supplier_id) : null,
        country_id: values.country_id ? Number(values.country_id) : null,
        province_id: values.province_id ? Number(values.province_id) : null,
        city_id: values.city_id ? Number(values.city_id) : null,
        district_id: values.district_id ? Number(values.district_id) : null,
        visibility: Boolean(Number(values.visibility)),
        not_show_in_catalog: Boolean(Number(values.not_show_in_catalog)),
        minimum_qty: values.minimum_qty === 0 ? 1 : Number(values.minimum_qty),
        group_qty: values.group_qty === 0 || values.group_qty === '' ? null : Number(values.group_qty),
        warehouses: values.warehouses ? [Number(values.warehouses)] : [],
      }
    }
  })
}